import React from 'react';

import { TMSContext } from 'contexts/tms';

type TMSProviderProps = React.PropsWithChildren<{
  tmsID: number;
  tmsName: string;
  tenant: string;
  isTestingEnvironment?: boolean;
}>;

export default function TMSProvider({
  children,
  isTestingEnvironment = false,
  ...rest
}: TMSProviderProps) {
  return (
    <TMSContext.Provider value={{ ...rest, isTestingEnvironment }}>
      {children}
    </TMSContext.Provider>
  );
}
